import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose } from 'underscore';
import { withMarketfilterContext } from 'InPlayOverview/helpers/market_filter';
import { inPlayOverviewChangeFilter } from 'InPlayOverview/duck';
import { ListModal } from 'bv-components';
import PeriodSelector from './period_selector';

export class MarketFilterComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.showMarketTypeSelectorModal = this.showMarketTypeSelectorModal.bind(this);
    this.hideMarketTypeSelectorModal = this.hideMarketTypeSelectorModal.bind(this);
    this.onMarketClick = this.onMarketClick.bind(this);
  }

  onMarketClick(marketType) {
    const { changeMarketType, sport } = this.props;
    changeMarketType(
      sport.id,
      marketType,
      marketType.periods[0],
    );
    this.hideMarketTypeSelectorModal();
  }

  showMarketTypeSelectorModal() {
    this.setState({
      expanded: true,
    });
  }

  hideMarketTypeSelectorModal() {
    this.setState({
      expanded: false,
    });
  }

  render() {
    const { sport, marketType, marketTypes } = this.props;
    const { expanded } = this.state;
    return (
      <div className="bvs-card__header-alternative inply-coupon-header ">
        <PeriodSelector sport={sport} />
        {
          marketType.mtId && marketTypes.length > 1
            && (
            <div className="inply-coupon-header__expand bvs-link" onClick={this.showMarketTypeSelectorModal}>
              <span />
              <span />
              <span />
            </div>
            )
        }
        {
          expanded && (
          <ListModal
            onCloseClick={this.hideMarketTypeSelectorModal}
            items={marketTypes}
            activeElement={marketType}
            idAttribute="mtId"
            descriptionAttribute="mtDesc"
            onItemClick={this.onMarketClick}
          />
          )
        }
      </div>
    );
  }
}

MarketFilterComponent.propTypes = {
  sport: PropTypes.instanceOf(Object).isRequired,
  marketTypes: PropTypes.instanceOf(Array).isRequired,
  marketType: PropTypes.instanceOf(Object).isRequired,
  changeMarketType: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  changeMarketType: compose(dispatch, inPlayOverviewChangeFilter),
});

export default withMarketfilterContext(connect(null, mapDispatchToProps)(MarketFilterComponent));
